import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../actions/userAction";
import Index from "./Index";

const RootContainer = (props) => {
  return <Index {...props} />;
};

function mapStateToProps(state) {
  const { accountReducer, bulkProcessReducer } = state;
  return {
    accountReducer,
    bulkProcessReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RootContainer);
